import React, { Component } from 'react';
import Axios from 'axios';
import {Link} from 'react-router-dom';
import Constant from '../Constant';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';

import '../../css/style.css';
import '../../css/custom.css';
import $ from 'jquery';
import { getAccessToken } from '../../hooks/AccessToken';


class DataManagement extends Component {
      
    state = {
        ERROR: true,
        DataList: [],
        selectValue: 'all', 
        length: '',
        pageNo: 1,
        defaultPageNo: 1,
        isLoading: true
    }

    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        })
    }; 

//----------------------------------Change status-----------------------------------------------\\

changeStatus = async (id, status) => {
    try {
        let token = getAccessToken();
        const response = await Axios.patch(Constant.apiBasePath+'event/changeStatus/'+ id, { status: status }, { headers: { 'token': token }});
        let {data} = response;
        if(data.status === Constant.statusSuccess) {
            $('#gen-message').text(data.message);
            $('#gen-message').css('color', 'green');
            this.handleSubmit(this.state.defaultPageNo);
        }
        else {
            $('#gen-message').text(data.message);
            $('#gen-message').css('color', 'red');
        }    
    }
    catch(err) {
        console.log(err);
    }
} 

//------------------------------------Integrate API for remove banner-------------------------------//

deleteEvent = async (event, thumbnail) => {
    try {
        let token = getAccessToken();
        const response = await Axios.delete(Constant.apiBasePath+'event/delete/' + event + '?thumbnail=' + thumbnail, { headers: { 'token': token }});
        let data = response.data;
        if(data.status === Constant.statusSuccess) {
            $('#gen-message').text(data.message);
            $('#gen-message').css('color', 'green');
            this.handleSubmit(this.state.defaultPageNo, this.state.selectValue);
            setTimeout(function() { $("#gen-message").text(''); }, 3000);
        }
        else {
            $('#gen-message').text(data.message);
            $('#gen-message').css('color', 'red');
            setTimeout(function() { $("#gen-message").text(''); }, 3000);
        }  

    }
    catch(err) {
         console.log(err);
    }
}

//----------------------------------Integrate show banner API----------------------------------\\

handleSubmit = async (pageNum = 1, filterValue = null) => {
    this.setState({ isLoading: true });
    try {
        let token = getAccessToken();
        let selectValue = filterValue !== null ? filterValue : this.state.selectValue;
        const response = await Axios.post(Constant.apiBasePath + 'event/get-all', { 'key': selectValue, 'pageNo': pageNum }, { headers: { 'token': token }});
        const {data, length, pageNo} = response.data;
        this.setState({DataList: data, length: length, pageNo: pageNo, defaultPageNo: pageNum, ERROR: false});
    }
    catch(err) {
        console.log(err);
    }
    finally {
        this.setState({ isLoading: false });
    }
}

handleFilterChange = (e) => {
    const value = e.target.value;
    this.setState({ selectValue: value }, () => {
        this.handleSubmit(1, value);
    });
}

//--------------------------------------------Reload component----------------------------------------------//    

componentDidMount() {
    this.handleSubmit(this.state.defaultPageNo);
}

//-------------------------------------------End API-------------------------------------------------------\\     

render() {
    const {DataList, length, pageNo, isLoading} = this.state;
    const currentPage = Number(pageNo) > 0 ? Number(pageNo) : 1;
    let i = (currentPage - 1) * Constant.perPage;
    
        let bodyData = '';
    if(!isLoading && DataList.length > 0) {
        bodyData = DataList.map((el, index) => {
            i++;
            let status = "Inactive";
            let statusClass = "is-inactive";
            if(el.status === 1) {
                status = "Active";
                statusClass = "is-active";
            } 

            return <tr key={index} className="table-row">
                <td className="sno-col">{i}</td>
                <td className="name-col">{el.name || '-'}</td>
                <td className="venue-col">{el.venue || '-'}</td>
                <td className="price-col">{el.price || '-'}</td>
                <td className="date-col">{el.date || '-'}</td>
                <td className="time-col">{el.time || '-'}</td>
                <td className="created-at-col">{el.createdAt || '-'}</td>
                <td className="status-col">
                    <button
                        type="button"
                        className={`contest-status-pill ${statusClass}`}
                        onClick={() => this.changeStatus(el._id, el.status === 1 ? 0 : 1)}
                        style={{ border: 0, cursor: 'pointer' }}
                    >
                        {status.toUpperCase()}
                    </button>
                </td>
                <td className="actions-col">
                    <button
                        type="button"
                        className="contest-icon-btn open-sessions-icon-btn danger event-action-btn"
                        onClick={() => {
                            if(window.confirm('Delete the Event?')) {
                                this.deleteEvent(el._id, el.thumbnail)
                            }
                        }}
                        title="Delete"
                        aria-label="Delete event"
                    >
                        <FontAwesomeIcon icon={faTrashAlt} style={{ fontSize: '13px' }} />
                    </button>
                </td>
            </tr>
        })
    }

        const totalPages = Number(length) > 0 ? Number(length) : 1;
        const previous = currentPage > 1 ? currentPage - 1 : 1;
        const next = currentPage < totalPages ? currentPage + 1 : totalPages;

   
        return (
                <div className="content-page contest-submissions-page contest-management-page event-management-page event-consistent-page">
               <div className="content page-content-spaced">
                        <div className="event-management-header">
                            <div className="header-content">
                                <div className="header-title">
                                    <h4 className="page-title-heading">Event Management</h4>
                                    <p className="header-subtitle">Manage event records and visibility status.</p>
                                </div>
                                <div className="header-actions">
                                    <select id="selectValue" value={this.state.selectValue} onChange={this.handleFilterChange} className="form-control filter-select" style={{ width: 240 }}>
                                        <option value="all">All</option>
                                        <option value="1">Active</option>
                                        <option value="0">Inactive</option>
                                    </select>
                                    <Link to="/create-event" className="btn btn-primary btn-add-event contest-add-match">
                                        + Add New
                                    </Link>
                                </div>
                            </div>
                        </div>
                        
                        <div className="event-management-body">
                            <div className="card event-management-card contest-like-card">
                                <div className="card-body">
                                    <p id="gen-message" className="message-feedback"></p>

                                    <div className="table-wrapper contest-submissions-table-responsive contest-like-table-responsive">
                                        <table id="complex-header-datatable" className="table event-table contest-submissions-table contest-like-table">
                                            <thead>
                                                <tr>
                                                    <th className="sno-col">S.No.</th>
                                                    <th className="name-col">Name</th>
                                                    <th className="venue-col">Venue</th>
                                                    <th className="price-col">Price</th>
                                                    <th className="date-col">Date</th>
                                                    <th className="time-col">Time</th>
                                                    <th className="created-at-col">Created At</th>
                                                    <th className="status-col">Status</th>
                                                    <th className="actions-col">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    isLoading
                                                    ?
                                                        <tr>
                                                            <td colSpan="9" className="table-loading-cell">
                                                                <span className="table-loading-spinner"></span>
                                                                Loading events...
                                                            </td>
                                                        </tr>
                                                    :
                                                    (DataList.length > 0)
                                                    ?
                                                        bodyData
                                                    :
                                                        <tr>
                                                            <td colSpan="9" className="table-loading-cell">No events found.</td>
                                                        </tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div> 

                                    <div className="pagination">
                                        {
                                            (currentPage <= 1) ?
                                        <button type="button" className="disabled" disabled>Previous</button>
                                        :
                                        <button type="button" className="paginate-link" onClick={() => this.handleSubmit(previous, this.state.selectValue)}>Previous</button>
                                        }

                                        <button type="button" className="page-number">{currentPage} / {totalPages}</button>
                                        {
                                            (currentPage >= totalPages)
                                            ?
                                        <button type="button" className="disabled" disabled>Next</button>
                                        :
                                        <button type="button" className="paginate-link active" onClick={() => this.handleSubmit(next, this.state.selectValue)}>Next</button>

                                        }
                                    </div>
                                </div>   
                            </div>
                        </div>
                    </div>
                </div>
        )
    }    
        
}
export default DataManagement;
